import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useAuthenticate, SessionTimeoutModal } from '@ibe/tupvid-components';
import { useLocation } from 'react-router-dom';
import PageUrl from '../Models/PageUrl';

// TODO: might need a refreshToken endpoint like in iso-lib
const SessionTimeoutWrapper = observer(() => {
  const auth = useAuthenticate();
  const location = useLocation();

  const [sessionExpirationTimeOut, setSessionExpirationTimeOut] = useState(
    (auth && auth.authenticateService.getRemainingTokenTime()) || null
  );

  useEffect(() => {
    setSessionExpirationTimeOut(auth.authenticateService.getRemainingTokenTime() || null);
  }, [auth.authenticateService, location, auth.authenticateState.token]);

  return (
    <>
      {sessionExpirationTimeOut && (
        <SessionTimeoutModal
          sessionTimeOut={sessionExpirationTimeOut}
          urlToGoBackTo={PageUrl.LOGOUT}
        />
      )}
    </>
  );
});

export default SessionTimeoutWrapper;
